import { render, staticRenderFns } from "./m_epidemic_training_public_teachers.vue?vue&type=template&id=d7c835ce&scoped=true"
import script from "./m_epidemic_training_public_teachers.vue?vue&type=script&lang=js"
export * from "./m_epidemic_training_public_teachers.vue?vue&type=script&lang=js"
import style0 from "./m_epidemic_training_public_teachers.vue?vue&type=style&index=0&id=d7c835ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c835ce",
  null
  
)

export default component.exports